<template>
  <div class="dropdown-container">
    <MultiSelect 
      v-model="selectedValues" 
      :options="options" 
      optionLabel="Glosa" 
      optionValue="Id" 
      placeholder="Selecciona Asignaturas" 
      :class="{'p-invalid': mostrarErrores && error}" 
      v-tooltip="tooltipOpts"
      @change="emitSelection"
      display="chip"
    />
    <small v-if="mostrarErrores && error" class="p-error">{{ error }}</small>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import AsignaturaService from '@/services/AsignaturaService'; // Importa el servicio
import { MultiSelect } from 'primevue/multiselect'; // Importa el componente MultiSelect

export default {
  components: {
    MultiSelect // Registra el componente MultiSelect
  },
  props: {
    mostrarErrores: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    modelValue: {
      type: Array, // Cambiado a Array para permitir múltiples selecciones
      default: () => []
    },
    /** Si se define, solo se listan asignaturas cuya Glosa contiene este texto (sin distinguir mayúsculas). */
    glosaContiene: {
      type: String,
      default: ''
    },
    /** Si se define, se excluyen asignaturas cuya Glosa contiene este texto (sin distinguir mayúsculas). */
    glosaNoContiene: {
      type: String,
      default: ''
    }
  },
  computed: {
    tooltipOpts() {
      return {
        value: this.tooltip || '',
        position: 'bottom',
        disabled: !String(this.tooltip || '').trim(),
      };
    },
  },
  setup(props, { emit }) {
    const options = ref([]);
    const selectedValues = ref(props.modelValue);

    const aplicarFiltrosGlosa = (lista) => {
      let raw = Array.isArray(lista) ? lista : [];
      const incluir = (props.glosaContiene || '').trim().toLowerCase();
      if (incluir) {
        raw = raw.filter((a) => (a.Glosa || '').toLowerCase().includes(incluir));
      }
      const excluir = (props.glosaNoContiene || '').trim().toLowerCase();
      if (excluir) {
        raw = raw.filter((a) => !(a.Glosa || '').toLowerCase().includes(excluir));
      }
      return raw;
    };

    const fetchOptions = async () => {
      try {
        const response = await AsignaturaService.get(); // Llama al método getAsignaturas
        options.value = aplicarFiltrosGlosa(response.data);
      } catch (error) {
        console.error('Error al cargar opciones:', error);
      }
    };

    const emitSelection = () => {
      emit('update:modelValue', selectedValues.value); // Emitir el array de valores seleccionados
    };

    onMounted(() => {
      fetchOptions(); // Llama a la función para cargar las opciones al montar el componente
    });

    return {
      options,
      selectedValues,
      emitSelection,
    };
  }
}
</script>

<style scoped>
.dropdown-container {
  margin-bottom: 1rem;
  max-height: 200px; /* Ajusta la altura máxima según sea necesario */
  overflow-y: auto; /* Permite el scroll vertical */
}

.p-multiselect {
  width: 100%; /* Asegúrate de que el MultiSelect ocupe el ancho completo */
}
</style>